import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

function Layout() {
  return (
    <>
      <Header />
      <main style={{padding: '', paddingBottom: '', minHeight: 'calc(100vh - 100px)'}}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default Layout;
